import { Record as record, List } from 'immutable';

import { getDefaults, getResolvers } from '../../helpers/Records';
import { construct, resolveAll } from '../../helpers/LinkMapper';
import Station from '../Station';
import TicketOffice from '../TicketOffice';
import PaperSeasonTicket from './PaperSeasonTicket';
import InvalidPaperSeasonTicket from './InvalidPaperSeasonTicket';

const fieldSchema = {
    "collectionLocation": [ resolveAll.as(Station), new List() ],
    "ticketOffices": [ resolveAll.as(TicketOffice), new List() ],
    "tickets": [ resolveAll.as(PaperSeasonTicket), new List() ],
    "invalidTickets": [ resolveAll.as(InvalidPaperSeasonTicket), new List() ]
};

class PaperSeasonTicketResults extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(PaperSeasonTicketResults, json, getResolvers(fieldSchema));
    }

    hasTickets () {
        return this.tickets && this.tickets.size > 0;
    }

    hasInvalidTickets () {
        return this.invalidTickets && this.invalidTickets.size > 0;
    }
}

export default PaperSeasonTicketResults;
